import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const mainColor = '#ffffff';
const altColor = '#f9f9f9';
const subduedColor = '#a2a2a2';
const darkBlueColor = '#0056b3';
const greenHightlight = '#6786a1';

const FirstSection = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: { xs: 'auto', md: '400px' },
                backgroundImage: 'url(/Klamath-Falls-banner-scaled.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'left center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* Shaded Overlay */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark overlay
                    zIndex: 1,
                }}
            />

            {/* Content Wrapper */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    maxWidth: '1200px',
                    width: '100%',
                    padding: '40px',
                }}
            >
                {/* Left Text Content */}
                <Box
                    sx={{
                        flex: 1,
                        textAlign: 'center',
                        color: '#ffffff',
                        marginBottom: { xs: '20px', md: 0 },
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 500,
                            marginBottom: '16px',
                            fontFamily: 'Roboto, sans-serif',
                        }}
                    >
                        Become an FAA-Certified Drone Pilot
                    </Typography>
                    <Typography variant="body1" sx={{ marginBottom: '12px', fontSize: '22px', fontFamily: 'Roboto, sans-serif', color: '#cccccc', fontWeight: 500, }}>
                        Everything you need to pass the Part 107 test
                    </Typography>
                    <Typography variant="body1" sx={{ marginBottom: '12px', fontSize: '16px', fontFamily: 'Roboto, sans-serif', color: '#ffffff', }}>
                        (No time limit, you are enrolled for life)
                    </Typography>
                    <Typography variant="body1" sx={{ marginBottom: '12px', fontSize: '16px', fontFamily: 'Roboto, sans-serif', color: '#ffffff', }}>
                        7,000+ students and growing
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            marginBottom: '24px',
                            fontSize: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontFamily: 'Roboto, sans-serif',
                            color: 'gold',
                        }}
                    >
                        ★★★★★{' '}
                        <span
                            style={{
                                color: '#ffffff',
                                marginLeft: '8px',
                            }}
                        >
                            4.7 based on 300 reviews
                        </span>
                    </Typography>
                    <Button
                        component="a"
                        href="https://www.pilotsed.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        sx={{
                            backgroundColor: '#ff9800',
                            color: '#fff',
                            fontWeight: 600,
                            fontSize: '16px',
                            textTransform: 'none',
                            padding: '12px 24px',
                            '&:hover': {
                                backgroundColor: '#fb8c00',
                            },
                        }}
                    >
                        Learn More
                    </Button>
                </Box>

                {/* Right Image */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src="/2-x-Devices-Promo-1.png"
                        alt="Promo Devices"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            borderRadius: '16px',
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

const PilotsEdPlatform = () => {
    const navigate = useNavigate();

    return (
        <Box>
            <div style={{ width: '100%', margin: 0 }}>
                <FirstSection />
            </div>
        </Box>
    );
};

export default PilotsEdPlatform;